<template>
  <pbc-overlay ref='modal' @close="onClose" :disable-title="true" @done='onDone'>
    <div class="overflow-hidden flex flex-col grow">
      <unified-add :render-tools='renderTools'
                  :transforms-and-source='transformsAndSource'
                  :partutil='partutil'
                  :holder-data='holderData'
                  :layers='layers'
                  :selected-layers='selectedLayers'
                  @add-children='$emit("add-children", $event); $emit("done")'
                  class='overflow-y-auto grow'
                  />
    </div>

  </pbc-overlay>
</template>
<script>
import UnifiedAdd from '@ui/organisms/UnifiedAdd.vue';
export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    selectedLayers: {
      type: Object,
      required: true
    },
    layers: {
      type: Object,
      required: true
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onDone() {
      this.$emit('done');
    },
  },
  components:{
    UnifiedAdd
  }

}
</script>
